import React, { useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import moment from "moment";
import {
  Button,
  ButtonIcon,
  InfoRowView,
  RadioBox,
  SelectBox,
  Tag,
} from "../..";
import * as actionTypes from "../../../store/actions/types";
import { connect, useDispatch, useSelector } from "react-redux";
import { GetIcon } from "../../../config/icon";
import { FiCopy } from "react-icons/fi";
import { Tabs } from "antd";
import { OpenNotification } from "../../../config/notification";
import { cooGetMerchantOfferCount } from "../../../containers/merchant/service/merchant.service";
import { RiCheckLine } from "react-icons/ri";

const Index = (props) => {
  const [isExpand, setIsExpand] = useState(false);
  const [offers, setOffers] = useState(null);
  const [noOfOffers, setNoOfOffers] = useState(0);
  const [isLoadingNoOfOffer, setIsLoadingNoOfOffer] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const { bankData } = useSelector(({ bankReducer }) => bankReducer);
  const { isSelectedExistingTerms } = useSelector(
    ({ termsReducer }) => termsReducer
  );

  const dispatch = useDispatch();

  const handleToggleExpand = async () => {
    setIsExpand(!isExpand);
    setIsLoadingNoOfOffer(true);
    let res = await cooGetMerchantOfferCount(props?.merchantId);
    setSelectedBankId(Number(res?.data?.data[0]?.totalCount));
    setIsLoadingNoOfOffer(true);
  };

  const { TabPane } = Tabs;

  // const onLoadMerchantOffers = async () => {
  //   let resOfferByMerchant = await cooGetOfferByMerchant(props?.merchantId);
  //   if (resOfferByMerchant?.data?.data) {
  //     setOffers(resOfferByMerchant?.data?.data);
  //   }
  // };

  return (
    <>
      <div
        className={`cco__category-card-extraSmall__wrapper d-flex flex-row justify-content-between align-items-center ${
          props.isActive || props.isSelect ? "isActive" : ""
        }`}
        onClick={props.onClick}
      >
        <div className={"d-flex flex-row align-items-center"}>
          <div className={"cco__ccew__logo"}>{GetIcon("customerInfo")}</div>

          <div
            className={"d-flex flex-column justify-content-center"}
            style={{ paddingLeft: "5px" }}
          >
            <div className={"cco__ccew__name"}>{props.categoryName}</div>

            <div className={"cco__ccew__id d-flex flex-row align-items-center"}>
              {props.categoryId}
              <div className={"cco__ccew__copy"}>
                <FiCopy />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`cco__ccew__checkbox  ${
            props.isSelect ? "is_active" : ""
          } `}
        >
          {props.isSelect && (
            <>
              <RiCheckLine />
            </>
          )}
        </div>
      </div>
      {isExpand && <div className="expanded-content">{}</div>}
    </>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

Index.defaultProps = {
  title: "",
};

const mapStateToProps = (state) => {
  return {
    isOpenSearchMerchant: state.merchantReducer.isOpenSearchMerchant,
    selectMerchant: state.merchantReducer.selectMerchant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickSelectedOffer: (payload) =>
      dispatch({ type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL, payload }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
